export const TRIMESTRE_ENUM = {
  PRIMER_TRIMESTRE: 1,
  SEGUNDO_TRIMESTRE: 2,
  TERCER_TRIMESTRE: 3,
  CUARTO_TRIMESTRE: 4,
} as const

export type TrimestreEnumType =
  (typeof TRIMESTRE_ENUM)[keyof typeof TRIMESTRE_ENUM]
